export const NAME_PROYECTO = 'Analytics'
export const NAME_TITLE_WEB = 'Analytics'
export const MODULO_APP = 'ANALYTICS'

export const OPTIONS_PROYECTO = [
    'Analisis de datos y visualizacion de KPIs',
    'Consultas contables en lenguaje natural',
    'Control financiero y gestion gerencial',
    'Reportes y analisis en tiempo real',
    'Integracion segura con el ERP TSI'
]